module.exports = __webpack_public_path__ + "rs.eb3be364.svg";